module.exports = __webpack_public_path__ + "media/images/gifts/care/sug_cuidar_4-64b08594cc12f2b9b30dc1bb66d092ad.jpg";